import { translate } from "app/filters/i18nFilter";
import { modalsTexts } from "app/pages/activation/components/RankWidget/texts";

export const createCampaignName = (name: string): string => translate(modalsTexts.defaultCampaignName, { name });
